import { travel, travelPage } from "../data/site";
import { cardBlurb, placeLabel, travelArticles } from "../data/travel";
import type { TravelArticle } from "../types";
import useTransitionTo from "../utils/useTransitionTo";
import Contact from "./Contact";
import Nav from "./Nav";
import Reveal from "./Reveal";

const ArticleCard = ({ a, index }: { a: TravelArticle; index: number }) => {
  const transitionTo = useTransitionTo();
  const href = "/travel/" + a.slug;
  return (
    <a
      className="dest-card dest-link"
      href={href}
      onClick={(e) => { e.preventDefault(); transitionTo(href); }}
    >
      <div className="dest-photo">
        {a.hero
          ? <img src={a.hero.src} srcSet={a.hero.srcSet} sizes="(max-width: 1000px) 100vw, 560px" alt={a.place} loading="lazy" />
          : <span className="dest-ph">photo coming</span>}
        <span className="dest-index">{String(index + 1).padStart(2, "0")}</span>
      </div>
      <div className="dest-body">
        <div className="dest-meta">
          <span className="dest-country">{placeLabel(a)}</span>
          <span className="dest-coord">{a.date}</span>
        </div>
        <h3 className="dest-place">{a.title}</h3>
        <p className="dest-blurb">{cardBlurb(a)}</p>
        <span className="dest-read">Read the story <span className="dest-read-arrow">→</span></span>
      </div>
    </a>
  );
};

const TravelPage = () => {
  const transitionTo = useTransitionTo();
  const n = travelArticles.length;

  return (
    <>
      <Nav />
      <main>
        <header
          className="travel-hero"
          style={{ "--travel-img": `url(${travel.image})` } as React.CSSProperties}
        >
          <div className="travel-hero-overlay" />
          <div className="travel-hero-content wrap">
            <a className="page-back light" href="/" onClick={(e) => { e.preventDefault(); transitionTo("/"); }}>← Back home</a>
            <div className="travel-eyebrow">
              <span className="sec-num light">✦</span>
              <span className="sec-kicker">Field Notes · the travel journal</span>
            </div>
            <h1 className="travel-hero-title">Horizons, <em>collected.</em></h1>
            <p className="travel-hero-lead">{travelPage.intro}</p>
          </div>
        </header>

        <section className="section dest-section">
          <div className="dest-note">
            <span className="dest-note-dot" />
            {n} {n === 1 ? "story" : "stories"} so far · {travelPage.note}
          </div>
          <div className="dest-grid">
            {travelArticles.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 2) * 80}>
                <ArticleCard a={a} index={i} />
              </Reveal>
            ))}
          </div>
        </section>

        <Contact />
      </main>
    </>
  );
};

export default TravelPage;
